import React from "react";
import Modal from "semantic-ui-react/dist/commonjs/modules/Modal";
import {Grid, Header} from "semantic-ui-react";
import DOCUMENT_EXAMPLES from "./documentExampleConstant";
import DocumentExampleCard from "./documentExampleCard";
import DocumentExamplesProTip from "./documentExamplesProTip";
import {CustomDivider, CustomModalHeader, S3Image} from "../../custom-common";
import IMAGE from "../../../constants/images";

const DocumentExamplesModal = ({onClose, display}) => (
    <Modal size={'large'} onClose={onClose} open={display} style={{maxWidth: 884}}>
        <CustomModalHeader title={"Types of documents"} onClose={onClose} className="customModalHeader"/>
        <Modal.Content className={"small"}>
            <Header color="blue" textAlign={"center"} as={"h2"}>Document examples</Header>
            <div className="centerAligned">
                <p className="uploadInstructionsModalDescription">
                    <S3Image {...IMAGE.CAMERA_ICON} verticalAlign='middle'/> Photos or scans of documents work just fine—
                </p>
            </div>
            <CustomDivider hidden/>
            <CustomDivider small hidden/>
            <div style={{display: 'flex', justifyContent: "space-around"}}>
                {DOCUMENT_EXAMPLES.map((documentExample, index) => <DocumentExampleCard key={index} {...documentExample} />)}
            </div>
            <CustomDivider small hidden/>
            <Grid container stackable columns={1} centered padded={'vertically'}>
                <Grid.Column>
                    <DocumentExamplesProTip/>
                </Grid.Column>
            </Grid>
        </Modal.Content>
    </Modal>
);

export default DocumentExamplesModal;
